var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.875,
    y: 2.41309,
    width: 5.35711,
    height: 9.64279,
    rx: 1,
    fill: "#9AC8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2189 13.0506L16.8398 0.786667C16.4776 0.454677 16.0041 0.270508 15.5128 0.270508C15.0215 0.270508 14.548 0.454677 14.1858 0.786667L0.808103 13.0506C0.641851 13.2034 0.525566 13.4028 0.474446 13.6228C0.423327 13.8427 0.439752 14.073 0.521573 14.2834C0.603394 14.4939 0.746807 14.6748 0.933065 14.8025C1.11932 14.9301 1.33976 14.9986 1.56557 14.999C2.92637 14.999 4.02953 16.1021 4.02953 17.463V27.4651C4.02953 27.8335 4.10209 28.1983 4.24308 28.5387C4.38406 28.879 4.59071 29.1883 4.85122 29.4488C5.11173 29.7093 5.421 29.916 5.76137 30.057C6.10174 30.1979 6.46654 30.2705 6.83496 30.2705H24.1906C24.559 30.2705 24.9238 30.1979 25.2642 30.057C25.6046 29.916 25.9138 29.7093 26.1744 29.4488C26.4349 29.1883 26.6415 28.879 26.7825 28.5387C26.9235 28.1983 26.996 27.8335 26.996 27.4651V17.4644C26.996 16.103 28.1 14.9996 29.4614 15.0004C29.6875 15.0003 29.9083 14.9319 30.0949 14.8042C30.2815 14.6765 30.4251 14.4954 30.507 14.2846C30.5889 14.0738 30.6052 13.8432 30.5538 13.623C30.5024 13.4029 30.3856 13.2033 30.2189 13.0506Z",
    fill: "url(#paint0_linear_524_22822)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.069 12.4928C11.7826 11.8098 12.6397 11.2946 13.5776 10.9849C14.0449 11.6274 14.8029 12.0452 15.6584 12.0452C16.514 12.0452 17.2719 11.6274 17.7392 10.9849C18.6772 11.2946 19.5342 11.8098 20.2479 12.4928C19.9467 13.2089 19.9722 14.0527 20.3906 14.7774C20.7877 15.4651 21.4544 15.9 22.1801 16.0256C22.2609 16.444 22.3015 16.8691 22.3012 17.2952C22.3012 17.8894 22.2232 18.4653 22.0769 19.0133C21.3915 19.161 20.7687 19.5866 20.3906 20.2416C20.2205 20.5353 20.1105 20.8598 20.0668 21.1963C20.0232 21.5328 20.0468 21.8747 20.1362 22.202C19.3685 22.904 18.4464 23.4155 17.4444 23.6951C16.9655 23.2316 16.3249 22.9728 15.6584 22.9737C14.9919 22.9728 14.3513 23.2316 13.8724 23.6951C12.8704 23.4154 11.9484 22.9039 11.1806 22.202C11.2701 21.8747 11.2937 21.5328 11.25 21.1963C11.2064 20.8598 11.0963 20.5353 10.9263 20.2416C10.5481 19.5867 9.92537 19.161 9.23988 19.0133C9.09054 18.4529 9.01515 17.8753 9.01563 17.2952C9.01563 16.8611 9.05731 16.4366 9.13681 16.0256C9.86248 15.9 10.5292 15.4651 10.9263 14.7774C11.3447 14.0527 11.3702 13.2088 11.069 12.4928ZM15.6584 20.5095C17.4337 20.5095 18.8727 19.0705 18.8727 17.2952C18.8727 15.52 17.4337 14.0809 15.6584 14.0809C13.8832 14.0809 12.4442 15.52 12.4442 17.2952C12.4442 19.0705 13.8832 20.5095 15.6584 20.5095ZM15.6584 18.9023C14.7116 18.9023 13.9442 18.1349 13.9442 17.1881C13.9442 16.2413 14.7116 15.4738 15.6584 15.4738C16.6053 15.4738 17.3727 16.2413 17.3727 17.1881C17.3727 18.1349 16.6053 18.9023 15.6584 18.9023Z",
    fill: "url(#paint1_linear_524_22822)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_22822",
    x1: 15.5142,
    y1: 0.270508,
    x2: 15.5142,
    y2: 30.2705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB9EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_524_22822",
    x1: 15.6584,
    y1: 10.9849,
    x2: 15.6584,
    y2: 23.6951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingActive);
export default "https://c.d2cgo.com/dtc_center-setting/v19/assets/static/media/setting_active.f8730da2bbf96c75f3ad896e544ba90d.svg";
export { ForwardRef as ReactComponent };